function setup() {

    console.log('setup loading scene');
}

export {setup};
